import React, { useState, useEffect } from "react";
import "./faculty_info.css";

const API_BASE = process.env.REACT_APP_API_BASE_URL || 'https://api.mitadtu.in';

const FacultyInfo = () => {
  const [faculty, setFaculty] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchFaculty();
  }, []);

  const fetchFaculty = async () => {
    try {
      const res = await fetch(`${API_BASE}/api/admin/faculty/public`);
      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || 'Failed to load faculty');
      }

      setFaculty((data.faculty || []).reverse());
    } catch (err) {
      console.error('Error fetching faculty:', err);
      setError('Failed to load faculty information');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="faculty-info-container">
        <h4 className="innerpage-heading ">Faculty Information</h4>
        <p>Loading faculty information...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="faculty-info-container">
        <h1 className="innerpage-heading ">Faculty Information</h1>
        <p className="error-message">{error}</p>
      </div>
    );
  }

  return (
    <div>
      <h1 className="title">Faculty Information</h1>
      <hr />
      <p>
        Meet our distinguished faculty members who are dedicated to excellence in maritime education.
      </p>

      {faculty.length === 0 ? (
        <div className="no-faculty">
          <p>No faculty information available at the moment.</p>
        </div>
      ) : (
        <div className="faculty-section">
          {faculty.map((member) => (
            <div key={member.id} className="faculty-card">
              <div className="faculty-image-container">
                {member.profile_picture ? (
                  <img
                    src={`${API_BASE}${member.profile_picture}`}
                    alt={member.name}
                    className="faculty-image"
                  />
                ) : (
                  <div className="faculty-image-placeholder">
                    <span>{member.name.charAt(0).toUpperCase()}</span>
                  </div>
                )}
              </div>
              <div className="faculty-info">
                <h3 className="innerpage-heading " id="faculty-name">{member.name}</h3>
                <p className="subtitle" id="faculty-desi">{member.designation}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FacultyInfo;
